<template>
  <div class="fill-height d-flex flex-column">
    <v-hover v-slot="{ hover }">
      <v-card
        class="position-relative flex-grow-1 rounded-lg d-flex flex-column mb-2 item-card" light
        style="box-shadow: 0 4px 5px -1px rgba(0, 0, 0, .05); border: 1px solid rgba(0, 0, 0, .08)"
      >
        <div class="fill-width py-2 px-3">
          <div class="px-2 text-left d-flex justify-start align-center text-capitalize">
            <v-list-item-avatar v-if="item.merchant_picture" class="m-0 mr-2" size="30">
              <img :src="item.merchant_picture" alt="user"/>
            </v-list-item-avatar>
            <v-avatar
              v-else size="30" class="d-flex align-center justify-center my-2 mr-2 text-body-2" color="blue lighten-4"
            >
              {{ initials(item.merchant_name) }}
            </v-avatar>
            <div class="d-flex flex-column">
              <span
                class="text-small font-weight-bold text-truncate"
                style="letter-spacing: 0; line-height: 1; max-width: 180px"
              >
                {{ item.merchant_name }}</span>
              <span class="text-small mt-1" style="letter-spacing: 0; line-height: 1">100+ products</span>
            </div>
          </div>
        </div>
        <div @click="$emit('select')" class="border-bottom position-relative d-block cursor-pointer">
          <div class="slight-overlay position-relative">
            <template v-if="item.secondary_picture">
              <ProxyImage
                :src="item.secondary_picture"
                v-show="hover && item.secondary_picture && !item.secondary_picture.match(/undefined|null/gi)"
              />
            </template>
            <ProxyImage
              :src="item.primary_picture"
              v-show="!hover || !item.secondary_picture || item.secondary_picture.match(/undefined|null/gi)"
            />
            <div v-if="$store.getters['cart/inCart'](item)" class="in-cart-indicator">
              <v-avatar color="green lighten-2" size="30">
                <v-icon color="white" small>mdi-cart-arrow-down</v-icon>
              </v-avatar>
            </div>
          </div>
        </div>
        <div
          style="box-shadow: 0 -8px 7px rgba(0, 0, 0, .09); z-index: 1;"
          class="px-4 py-4 px-md-4 flex-grow-1 d-flex flex-column align-start"
        >
          <div
            v-if="item.monthly_amount < 1000000 && item.monthly_amount > 2000"
            class="d-flex align-center justify-space-between fill-width"
          >
            <div class="text-small black--text font-weight-bold ma-0">
              {{ item.monthly_amount | currency }}/mo • {{ item.no_of_months }} month(s)
            </div>
            <v-btn @click="addLike()" small icon>
              <v-icon color="red" v-if="liked">mdi-heart</v-icon>
              <v-icon v-else>mdi-heart-outline</v-icon>
            </v-btn>
          </div>
          <div :title="item.name" class="black--text text-body-2 fill-width mt-1 overflow-hidden" style="height: 40px">
            {{ item.name }}
          </div>
          <div
            v-if="item.monthly_amount < 1000000 && item.monthly_amount > 2000"
            class="border-top mt-2 pt-4 fill-width"
          >
            <div class="d-flex align-center fill-width">
              <v-text-field
                :value="quantity" dense hide-details outlined readonly style="max-width: 120px" height="20px"
              >
                <v-icon @click="decrementQuantity()" color="red" slot="prepend">mdi-minus</v-icon>
                <v-icon @click="incrementQuantity()" color="green" slot="append-outer">mdi-plus</v-icon>
              </v-text-field>
              <v-btn @click="addToCart()" class="flex-grow-1 ml-3" color="primary" elevation="0" outlined>
                <v-icon class="mr-2" size="20">mdi-cart-plus</v-icon>
                Add to cart
              </v-btn>
            </div>
          </div>
          <div v-else class="border-top mt-2 pt-4 fill-width mt-auto">
            <div class="d-flex align-center fill-width">
              <v-text-field
                :value="quantity" dense hide-details outlined readonly style="max-width: 120px" height="20px"
              >
                <v-icon @click="decrementQuantity()" color="red" slot="prepend">mdi-minus</v-icon>
                <v-icon @click="incrementQuantity()" color="green" slot="append-outer">mdi-plus</v-icon>
              </v-text-field>
              <v-btn @click="requestPrice()" class="flex-grow-1 ml-3" color="primary" elevation="0" outlined>
                <v-icon class="mr-2" size="20">mdi-help-circle</v-icon>
                Request price
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import card from "../../../mixins/items/card";
import ProxyImage from "../../ProxyImage";

export default {
  name: "ItemCardMerchant",
  components: { ProxyImage },
  mixins: [card],
  methods: {
    initials: name => {
      return name && name.substring(0, 2).toUpperCase();
    },
    addToCart() {
      this.$store.commit('cart/addItem', { ...this.item, unit: this.quantity });
      this.$bus.$emit('cart');
    },
    requestPrice() {
      this.$store.commit('cart/addItem', {
        ...this.item,
        monthly_amount: 0,
        price: 0,
        credit_price: 0,
        unit: this.quantity
      });
      this.$bus.$emit('cart');
    }
  }
}
</script>

<style lang="scss" scoped>
.offscreen {
  position: absolute;
  top: 0;
  right: -100px;
  transition: all .15s ease-in-out;
  z-index: 1;

  &.visible {
    right: 0
  }
}

.merchant-btn {
  width: 100%;
  transition: all .15s ease-in-out;
  border-radius: 999px;

  &:hover {
    padding: 6px 8px;
    background: #eee;
  }
}


::v-deep {
  .offscreen {
    position: absolute;
    top: 0;
    right: -100px;
    transition: all .15s ease-in-out;
    z-index: 1;

    &.visible {
      right: 0
    }
  }
}

</style>
